;(function (angular) {
  'use strict'

  angular
    .module('kilo.common.filters')
    .filter('bytes', BytesFilter)

  function BytesFilter () {
    /**
     * Format text as data storage format ( bytes, kB, MB ... )
     * @param bytes
     * @param precision
     * @returns {*}
     */
    var operation = function (bytes, precision) {
      if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-'
      if (typeof precision === 'undefined') precision = 1
      var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB']
      var number = Math.floor(Math.log(bytes) / Math.log(1024))
      return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number]
    }

    return operation
  }
})(window.angular)
